<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="developer-screen">
    <h3 class="heading">{{ 'developer.just-getting-started' | translate }}</h3>

    <div class="developer-card">
      <div class="inner-card">

        <img src="../../../../assets/images/dev.png" class="dev" alt="">
        <h2>{{ 'developer.not-a-developer' | translate }}</h2>
        <p>
          Use <a href="javascript:void(0)">luqta’s API Keys</a> {{ 'developer.download-resources' | translate }}
        </p>

        <!-- Client Name -->
        <div class="form-group">
          <label class="form-label">{{ "developer.apiKeySectionTitle1" | translate }}</label>
          <input type="text" class="form-control" placeholder="Enter client name" [(ngModel)]="clientName"
            [disabled]="isDisabled" />
        </div>

        <!-- API Key Management -->
        <div class="form-group">
          <label class="form-label">{{ "developer.apiKeySectionTitle2" | translate }}</label>

          <div class="api-key">
            <input type="text" class="form-control" [value]="apiKey" readonly #apiKeyInput
              placeholder="{{ 'developer.apiKeyPlaceholder' | translate }}" />

            <button class="btn btn-copy" type="button" (click)="copyApiKey(apiKeyInput)">
              {{ (copied ? "developer.copied" : "developer.copy") | translate }}
            </button>
          </div>
        </div>

        <!-- Generate Button -->
        <button class="btn btn-primary btn-sm width-fit" [disabled]="!clientName" (click)="generateApiKey(clientName)">
          {{ isApiKey ? ('developer.regenerate-api-key' | translate) : ('developer.generate-api-key' | translate) }}
        </button>
      </div>

      <!-- RIGHT SIDE CARD -->
      <div class="inner-card">
        <div class="client-libraries-card">

          <h3>{{ 'developer.client-libraries' | translate }}</h3>
          <p>{{ "developer.downloadsDescription" | translate }}</p>

          <div class="libraries">
            <div class="library">
              <img src="../../../../assets/images/lib1.png" alt="">
              <span>Ruby</span>
            </div>
            <div class="library">
              <img src="../../../../assets/images/lib2.png" alt="">
              <span>Java</span>
            </div>
            <div class="library">
              <img src="../../../../assets/images/lib3.png" alt="">
              <span>Node.Js</span>
            </div>
            <div class="library">
              <img src="../../../../assets/images/lib4.png" alt="">
              <span>Python</span>
            </div>
          </div>

          <div class="bottom">
            <button class="btn btn-primary-outline btn-sm w-100" (click)="downloadDummyPdf()">
              {{ "developer.downloadPdfButton" | translate }}
            </button>

            <button class="btn btn-primary btn-sm w-100" (click)="downloadCollection()">
              {{ "developer.downloadCollectionButton" | translate }}
            </button>
          </div>

        </div>
      </div>
    </div>

    <div class="authentication-guide-card">
      <h3>
        Authentication guide for contests API Endpoints
      </h3>
      <div class="guide-card">
        <div class="gc-header">
          <span>{{ 'developer.endpoint' | translate }}</span>
        </div>
        <div class="gc-body">
          <div class="code">
            https://xi5f-5y62-kbyr.n7e.xano.io/api:BB6HooOR/luqtaWebhook
          </div>
          <h4>
            Endpoint
          </h4>
          <p>
            Use apiKey in the "Header" authorization=YOUR_ApiKEY
          </p>
        </div>
      </div>
      <div class="guide-card">
        <div class="gc-header">
          <span>{{ 'developer.example-curl' | translate }}</span>
        </div>
        <div class="gc-body">
          <div class="code">
            curl -G "https://xi5f-5y62-kbyr.n7e.xano.io/api:BB6HooOR/luqtaWebhook"\
            <br>
            --data-urlencode "apiKey=YOUR_KEY"
          </div>
          <h4>
            Response: JSON list of contests
          </h4>
        </div>
      </div>
      <div class="guide-card">
        <div class="gc-header">
          <span>{{ 'developer.key-points' | translate }}</span>
        </div>
        <div class="gc-body">
          <ul>
            <li>
              <span>
                <b>APIkey</b> is required
              </span>
            </li>
            <li>
              <span>
                Error handling: returns error if <b>apikey</b> is invalid
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>



  <!-- <section class="developer-page container mb-5">
    <h1>{{ "developer.title" | translate }}</h1>
    <h6>{{ "developer.description" | translate }}</h6>
    <div class="api-key-section card mb-4">
      <div class="card-body">
        <div class="mb-3">
          <label for="clientName" class="form-label">{{
            "developer.apiKeySectionTitle1" | translate
            }}</label>
          <input type="text" id="clientName" name="clientName" class="form-control" [(ngModel)]="clientName"
            placeholder="Enter client name" [disabled]="isDisabled" />
        </div>
        <div class="mb-3">
          <label for="apiKeyInput" class="form-label">{{
            "developer.apiKeySectionTitle2" | translate
            }}</label>
          <div class="input-group">
            <input type="text" id="apiKeyInput" class="form-control" [value]="apiKey" readonly #apiKeyInput
              placeholder="{{ 'developer.apiKeyPlaceholder' | translate }}" />
            <button class="btn btn-primary" type="button" (click)="copyApiKey(apiKeyInput)" style="gap: 10px">
              <i class="fa -solid" [class.fa-copy]="!copied" [class.fa-check]="copied"></i>
              {{ (copied ? "developer.copied" : "developer.copy") | translate }}
            </button>
          </div>
        </div>
        <div class="mb-3 text-end">
          <button class="btn btn-primary" type="button" [disabled]="!clientName" (click)="generateApiKey(clientName)">
            {{ isApiKey ? "Regenerate ApiKey" : "Generate ApiKey" }}
          </button>
        </div>
      </div>
    </div>
    <div class="downloads-section card">
      <div class="card-body">
        <h5 class="card-title">
          {{ "developer.downloadsSectionTitle" | translate }}
        </h5>
        <p>{{ "developer.downloadsDescription" | translate }}</p>
        <div class="d-flex gap-2">
          <button class="btn btn-info" type="button" (click)="downloadDummyPdf()">
            <i class="fa-solid fa-file-pdf me-2"></i>{{ "developer.downloadPdfButton" | translate }}
          </button>
          <button class="btn btn-success" type="button" (click)="downloadCollection()">
            <i class="fa-solid fa-cloud-arrow-down me-2"></i>{{ "developer.downloadCollectionButton" | translate }}
          </button>
        </div>
      </div>
    </div>
  </section> -->
  <!-- <div class="promax">
    <div class="wrap">
      <h1>{{ "developer.heading" | translate }}</h1>
      <p>{{ "developer.description2" | translate }}</p>
      <div class="card">
        <h2>Endpoint</h2>
        <p>
          <code>https://xi5f-5y62-kbyr.n7e.xano.io/api:BB6HooOR/luqtaWebhook</code>
        </p>
        <p>
          <strong>Authorization</strong><br />Use <code>apiKey</code> in the
          "Header"
          <code>authorization=YOUR_ApiKEY</code>
        </p>
      </div>
      <div class="card">
        <h2>Example (curl)</h2>
        <pre>
curl -G "https://xi5f-5y62-kbyr.n7e.xano.io/api:BB6HooOR/luqtaWebhook"\
  --data-urlencode "apiKey=YOUR_KEY"</pre>
        <p>Response: JSON list of contests</p>
      </div>
      <div class="card">
        <h2>Key Points</h2>
        <ul>
          <li><code>apiKey</code> is required</li>
          <li>Error handling: returns error if <code>apiKey</code> is invalid</li>
        </ul>
      </div>
    </div>
  </div>
</div> -->